export default __webpack_public_path__ + "static/media/close.ff15200c.svg";